<template>
  <div class="block-chain-off-chain-manage">
    <action-bar>
      <search v-model="inputContent" placeholder="请输入节点ID" @onSearch="handleSearch"></search>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="list"
      :operator="operator"
      :show-edit="true"
      :paging="paging"
      @pagination="handleSizeOrPageChange"
    >
      <template slot="status" slot-scope="{ param }">
        <span class="subscribe-status" :class="param.row.status | transStatusClass">{{
          param.row.status | transStatus($constants.EMPTY)
        }}</span>
      </template>
    </normal-table>
    <create-node
      ref="createNode"
      @createNodeSuccess="onCreateNodeSuccess"
      @update:list="getList()"
    ></create-node>
    <deploy-contract ref="deployContract" @update:list="getList()"></deploy-contract>
    <download-dialog
      :dialog-visible.sync="showDownloadDialog"
      title="下载扩容节点部署包"
      :file-url="downloadUrl"
      :file-name="downloadFileName"
      :sure-text="downloadSureText"
      :cancel-text="downloadCancelText"
    ></download-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import createNode from './createNode'
import deployContract from './deployContract' //合约
import auth from '@/auth/index'

export default {
  name: 'Index',
  components: {
    createNode,
    deployContract
  },
  filters: {
    transStatus: function(value, defaultVal) {
      if (value == 0) {
        return '未订阅'
      } else if (value == 1) {
        return '已订阅'
      } else {
        return defaultVal
      }
    },
    transStatusClass: function(value) {
      if (value == 0) {
        return 'is-failed'
      } else if (value == 1) {
        return 'is-success'
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      inputContent: '',
      fullscreenLoading: false, //下载loading
      offchainId: '',
      list: [],
      paging: {
        offset: 0,
        limit: 10,
        total: 0
      },
      btnList: [
        {
          btnContent: '新建扩容节点',
          click: () => {
            return this.createExpansionNode()
          },
          icon: 'icon-add',
          auth: auth.blockchain.checkDetail.nodeExpansion.create
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'userNodeId',
          label: '扩容节点ID',
          formatter: row => {
            if (row.userNodeId == '') {
              return '未获取'
            }
            return row.userNodeId
          },
          minWidth: 182
        },
        {
          prop: 'userId',
          label: '用户ID',
          minWidth: 131
        },
        {
          prop: 'serverIP',
          label: 'IP地址',
          minWidth: 116
        },
        {
          prop: 'serverPort',
          label: 'IP端口',
          minWidth: 116
        },
        {
          prop: 'sp2pPort',
          label: 'p2p端口',
          minWidth: 174
        },
        {
          prop: 'status',
          label: '订阅状态',
          formatter: row => {
            return this.subscribeStatus(row.status)
          },
          minWidth: 116,
          slotName: 'status'
        },
        {
          prop: 'updateAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 175
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '订阅',
          click: (row, col, cellValue) => {
            return this.handleSubscribe(row)
          },
          icon: 'icon-subscribe',
          isText: true,
          formatter: (row, col, cellValue) => {
            return row.status == 0
          }
        },
        {
          text: '通道',
          click: (row, col, cellValue) => {
            return this.handleToChannel(row)
          },
          icon: 'icon-channel',
          isText: true
        },
        {
          text: '下载',
          click: (row, col, cellValue) => {
            return this.startDownload(row)
          },
          icon: 'icon-download',
          isText: true
        }
      ],
      operateCol: {
        minWidth: 157
      },
      //下载链下扩容节点部署包
      showDownloadDialog: false,
      downloadSureText: '立即下载',
      downloadCancelText: '稍后下载',
      downloadFileName: '扩容节点部署包',
      downloadUrl: ''
    }
  },
  computed: {
    // ...mapState({
    //   list: state => state.chain.chain_off_chain_node_list,
    //   paging: state => state.chain.chain_off_chain_node_paging
    // })
  },

  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getOffchainNodeLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        chainId: this.$route.query.chainId
      }
      // this.getOffchainNodeLists(params)
      this.$apis.chain
        .getOffchainNodeList(params)
        .then(res => {
          if (res.errors) {
            if (res.errors[0].code == 40011) {
              this.$refs.deployContract.handleOpen(res.data)
            }
          } else {
            this.list = res.data.items
            this.paging.limit = res.data.limit
            this.paging.offset = res.data.offset
            this.paging.total = res.data.total
          }
        })
        .catch(err => {})
    },
    subscribeStatus(status) {
      let statusArr = ['未订阅', '已订阅']
      return statusArr[status]
    },

    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    handleSearch(val) {
      this.inputContent = val
      this.getList()
    },
    handleSubscribe(row) {
      this.$confirm('确认订阅？')
        .then(_ => {
          this.$apis.chain
            .subscribeOffChain({ offChainId: row.id })
            .then(res => {
              if (res) {
                this.$message.success('订阅成功')
                this.getList()
              }
            })
            .catch(err => {
              this.disabled = false
            })
          done()
        })
        .catch(_ => {})
    },
    handleToChannel(row) {
      this.$router.push({
        name: 'channel',
        query: {
          chainId: this.$route.query.chainId,
          detail: JSON.stringify(row)
        }
      })
    },
    refresh() {
      this.inputContent = ''
      this.getList()
    },
    //下载
    startDownload(row) {
      this.onCreateNodeSuccess(row.id)
    },
    createExpansionNode(row) {
      this.$refs.createNode.handleOpen(row)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    onCreateNodeSuccess(offChainId) {
      this.downloadUrl = `/cbaas-service/v1/offchain/downloadOffChain?offChainId=${offChainId}`
      this.showDownloadDialog = true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-off-chain-manage',
  (
    --block-chain-off-chain-manage-list-operate-color: #45c2ff,
    --block-chain-off-chain-manage-list-operate-danger-color: #e95757,
    --block-chain-off-chain-manage-list-status-success: #55da62,
    --block-chain-off-chain-manage-list-status-failed: #e95757
  ),
  (
    --block-chain-off-chain-manage-list-operate-color: #45c2ff,
    --block-chain-off-chain-manage-list-operate-danger-color: #e95757,
    --block-chain-off-chain-manage-list-status-success: #55da62,
    --block-chain-off-chain-manage-list-status-failed: #e95757
  )
);
.block-chain-off-chain-manage {
  @include adaptation(
    (
      --block-chain-off-chain-manage-unavaliable-height: 166px
    )
  );
  --block-chain-off-chain-manage-min-height: calc(
    var(--base-main-router-body-avaliable-height) -
      var(--block-chain-off-chain-manage-unavaliable-height)
  );
  .btn-list-style {
    width: 100%;
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--block-chain-off-chain-manage-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--block-chain-off-chain-manage-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--block-chain-off-chain-manage-min-height);

        .subscribe-status {
          &.is-success {
            color: var(--block-chain-off-chain-manage-list-status-success);
          }

          &.is-failed {
            color: var(--block-chain-off-chain-manage-list-status-failed);
          }
        }

        .operate-item {
          color: var(--block-chain-off-chain-manage-list-operate-color);

          &.operate-danger {
            color: var(--block-chain-off-chain-manage-list-operate-danger-color);
          }
        }
      }
    }
  }
}
</style>
